import React from "react";

const FormGroup = ({
  Id,
  Label,
  Type,
  onChange,
  Value,
  defaultValue,
  Checked,
  defaultChecked,
  Placeholder,
  readOnly,
  Desc,
  Error
}) => {
  return (
   
    <div className="form-group">
      <label htmlFor={Id}>{Label}</label>
      {
        Type === "textarea" ? (
          <textarea
            className="form-control"
            id={Id}
            name={Id}
            onChange={onChange}
            value={Value}
            placeholder={Placeholder}
            aria-describedby={Id + "Help"}
            readOnly={readOnly}
          />
        ):(
          <input
            type={Type}
            className="form-control"
            id={Id}
            name={Id}
            onChange={onChange}
             {...(Type === "file" ? {} : { value: Value })}
            placeholder={Placeholder}
            defaultValue={defaultValue}
            checked={Checked}
            defaultChecked={defaultChecked}
            aria-describedby={Id + "Help"}
            readOnly={readOnly}
          />
        )
      }
       
      {/* {Desc && (
        <small id={Id + "Help"}
        style={{color:"grey"}}
        className=" text-slate-500">
          {Desc}
        </small>
      )} */}

      {Error && (
        <small id={Id + "Help"}
        style={{color:"red"}}
        className=" text-slate-500">
          {Label} is required
        </small>
      )}


    </div>
    
  );
};

export default FormGroup;